<div class="admin-columns">
	<div class="admin-column tree">
		@if (treenodes === undefined) {
		<div class="loading-status">
			<div class="logo-spin"></div>
			Loading...
		</div>
		}
		@if (treenodes) {
		<div class="asset-tree scrollable">
			@for (org of treenodes; track org) {
			<div class="org-wrapper">
				<div class="org-row expandable" [attr.data-orgid]="org.organization_id">
					<a (click)="ClickExpander($event)" class="expander-icon" [class.expanded]="org.expanded" [class.blank]="!(org.configs && org.configs.length > 0)"></a>
					<a class="org-link" (click)="ClickOrg($event)">{{org.name}}</a>
				</div>
				@for (config of org.configs; track config) {
				<div class="expandable-children">
					<a href="javascript:void(0)" (click)="ClickConfig($event, config)" class="fleet-link" [class.selected]="selectedItem === config">{{config.asset_type_name}}</a>
				</div>
				}
			</div>
			}
		</div>
		}
	</div>
	<div class="admin-column main">
		@if (selectedConfig) {
		<div>
			<div class="panel flush">
				<div class="heading">Select assets to use in calculations</div>
				<div class="content">
					@for (asset of selectedConfig.assets; track asset) {
					<div class="mb-3 form-check">
						<label [title]="asset.acqcount < 20 ? 'Not enough acquisitions (at least 20 required)' : ''">
							<input [(ngModel)]="asset.checked" [disabled]="asset.acqcount < 20" type="checkbox">
							{{asset.fleet_name ? asset.fleet_name : "(No fleet)"}} / {{asset.asset_name}} ({{asset.obcu_serial_number}})
						</label>
					</div>
					}
					<app-action-button [action]="UpdateThresholds" [context]="this" processing="Generating...">Generate thresholds</app-action-button>
				</div>
			</div>
		</div>
		}
	</div>
</div>
@if (thresholdComponents !== null) {
<div class="panel">
	<div class="heading">Thresholding results</div>
	@if (thresholdComponents === undefined && !thresholdError) {
	<div class="content">Loading...</div>
	}
	@if (thresholdComponents === undefined && thresholdError) {
	<div class="content message-bad">{{thresholdError}}</div>
	}
	@if (thresholdComponents) {
	<div class="content">
		<div class="row">
			<div class="col-md-6">
				<div class="row">
					<label class="col-md-3 col-form-label">Component:</label>
					<div class="col-md-9">
						<select class="form-control form-control-sm" [(ngModel)]="selectedComponent" (ngModelChange)="UpdateComponent($event)">
							@for (component of thresholdComponents; track component) {
							<option [ngValue]="component">
								{{component.description}}
								({{component.key}})</option>
							}
						</select>
					</div>
				</div>
				<div class="row mt-3">
					<div class="col-3">Scale:</div>
					<div class="col-9">{{selectedComponent.thresholds.scale | roundlist : 4}}</div>
				</div>
				<div class="row mt-3">
					<div class="col-3">Offset:</div>
					<div class="col-9">{{selectedComponent.thresholds.offset | roundlist : 4}}</div>
				</div>
				<div class="row mt-3">
					<div class="col-3">Mean:</div>
					<div class="col-9">{{selectedComponent.thresholds.mean | roundlist : 4}}</div>
				</div>
				<div class="row mt-3">
					<div class="col-3">Warning:</div>
					<div class="col-9">{{selectedComponent.thresholds.warn | roundlist : 4}}</div>
				</div>
				<div class="row mt-3">
					<div class="col-3">Alarm:</div>
					<div class="col-9">{{selectedComponent.thresholds.alarm | roundlist : 4}}</div>
				</div>
			</div>
			<div class="col-md-6">
				<app-dvs-chart [options]="boxPlotOptions"></app-dvs-chart>
			</div>
		</div>
	</div>
	}
</div>
}
@if (newConfig) {
<div class="row">
	<div class="col-lg-6">
		<div class="panel flush">
			<div class="heading">Updated asset configuration</div>
			<div class="content">
				<textarea [(ngModel)]="newConfig" class="form-control" style="min-height: 400px;"></textarea>
			</div>
		</div>
	</div>
	<div class="col-lg-6">
		<p class="text-danger">Note: Updating the configuration will overwrite the existing configuration in the database!</p>
		<app-action-button [action]="UploadConfig" [context]="this" processing="Updating..." complete="Config updated">Update Config</app-action-button>
	</div>
</div>
}